module.exports = __webpack_public_path__ + "static/media/arrow-down.b7e78939.svg";